import React, { useEffect, useState } from 'react'
import AliceCarousel from 'react-alice-carousel';
import 'react-alice-carousel/lib/alice-carousel.css';
import { firestore } from '../firebase';
import { collection, getDocs } from "firebase/firestore";

// función para prevenir el arrastre de imágenes al hacer clic
const handleDragStart = (e) => e.preventDefault();

const Slides = () => {
  // inicializa el estado de slides como un array vacío
  const [slides, setSlides] = useState([]);

  // carga los datos de Firestore en el estado de slides al montar el componente
  useEffect(() => {
    const fetchData = async () => {
      const querySnapshot = await getDocs(collection(firestore, "slides"));
      const slidesData = querySnapshot.docs.map(doc => doc.data());
      setSlides(slidesData);
    };
    fetchData();
  }, []);

  // crea un array de elementos img para pasar al componente AliceCarousel
  const items = slides.map((slide) => (
    <img 
      src={slide.url} 
      onDragStart={handleDragStart} 
      role="presentation" 
      style={{ width: '100%', height: 'auto' }} // establece el ancho en 100% y la altura automática para cada imagen
      loading='lazy'
    />
  ));

  // opciones de configuración para el componente AliceCarousel
  const responsive = {
    0: { items: 1 },
    576: { items: 2 },
    768: { items: 3 },
    992: { items: 4 },
    1200: { items: 5 }
  };

  // renderiza el componente AliceCarousel con los elementos img y las opciones de configuración
  return (
    <AliceCarousel 
      mouseTracking
      items={items}
      responsive={responsive}
      autoPlayInterval={3000}
      autoPlayDirection="ltr"
      autoPlay
      infinite
    />
  );
}

export default Slides;
